import { AuditState } from '../../../../model/AuditState';
import { ConfigServiceProvider } from '../config-service/config-service';
import { DeliveryStatus } from '../../../clients/model/client.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageServiceProvider } from '../storage-service/storage-service';

/*
  Generated class for the TextServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class TextServiceProvider {
  text = {
    loadingTitle: 'Ładowanie',
    loadingMessage: 'Trwa ładowanie danych...',
    networkErrorTitle: 'Błąd sieci',
    networkErrorText: 'Upewnij się, że Twoje urządzenie jest podłączone do internetu.',
    networkErrorButton: 'Spróbuj ponownie',
    newerVersionTitle: 'Aktualizacja',
    newerVersionText: 'Dostępna jest nowsza wersja aplikacji, pobierz ją aby kontynuować.',
    newerVersionButton: 'Pobierz',
    newerVersionLater: 'Może później',
    loginErrorTitle: 'Błąd logowania',
    loginErrorText: 'Upewnij się, że wpisane dane są prawidłowe i spróbuj ponownie',
    loginErrorButton: 'Zamknij',
    defaultErrorTitle: 'Wystąpił błąd',
    defaultErrorText: 'Wystąpił nieoczekiwany błąd, prosimy spróbować ponownie później.',
    defaultErrorButton: 'OK',
    defaultInfoTitle: 'Informacja',
    defaultInfoButton: 'OK',
    serviceNotReachable: 'Remote service cannot be reached. Please contact with support',
    serviceNotReachableTitle: 'Service not reachable',
    serviceInternalError: 'Error has occurred while trying to sign in. Please contact with support',
    serviceInternalErrorTitle: 'Error occurred',
    eventsStatePENDING: 'ZAPLANOWANA',
    eventsStateDONE: 'ZREALIZOWANA',
  };
  language = null;
  constructor(public http: HttpClient, private configService: ConfigServiceProvider, private storageService: StorageServiceProvider) {}

  get(identifier): string {
    if (this.language) {
      return this.text[this.language][identifier] || null;
    }
    return this.text[identifier] || null;
  }

  load() {
    return new Promise<void>((resolve, reject) => {
      this.http
        .get(this.configService.getUrl('text'))
        .toPromise()
        .then((response: any) => {
          this.text = Object.assign({}, this.text, response.params);
          this.storageService.setObject('text', response.params);
          resolve();
        })
        .catch((reason) => reject(reason));
    });
  }

  loadLocal() {
    return new Promise((resolve, reject) => {
      this.storageService
        .getObject('text')
        .then((response: any) => {
          this.text = Object.assign({}, this.text, response);
          resolve();
        })
        .catch((reason) => reject(reason));
    });
  }

  public getEventTypeText(type: string): string {
    switch (type) {
      case 'PRESENTATION':
        return this.get('eventTypePresentation');
      case 'NEGOTIATION':
        return this.get('eventTypeNegotiation');
      case 'RELATIONAL':
        return this.get('eventTypeRelational');
      case 'TRAINING':
        return this.get('eventTypeTraining');
      case 'COACHING':
        return this.get('eventTypeCoaching');
      default:
        return 'NIEZNANE';
    }
  }

  public getEventStatusText(type: string): string {
    if (type === 'PLANNED') {
      return this.get('eventStatusPlanned');
    } else if (type === 'COMPLETED') {
      return this.get('eventStatusCompleted');
    }

    return 'NIEZNANE';
  }

  public getAuditState(state: string): string {
    if (state === AuditState.PENDING) {
      return this.get('auditStatePending');
    } else if (state === AuditState.REJECTED) {
      return this.get('auditStateRejected');
    } else if (state === AuditState.APPROVED) {
      return this.get('auditStateApproved');
    }

    return 'NIEZNANY';
  }

  public getDeliveryStatusText(deliveryStatus: DeliveryStatus): string {
    switch (deliveryStatus) {
      case DeliveryStatus.DELIVERY:
        return this.get('clientDeliveryStatusDELIVERY');
      case DeliveryStatus.DELIVERY_PICKUP:
        return this.get('clientDeliveryStatusDELIVERY_PICKUP');
      case DeliveryStatus.PICKUP:
        return this.get('clientDeliveryStatusPICKUP');
      default:
        return 'NIEZNANY';
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/text-service/text-service.ts